import React from 'react';
import { useAppState } from 'state';
import { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs';

const DynamicClientBreadCrumb: React.FC<BreadcrumbComponentProps> = () => {
    const { currentItem } = useAppState().clients
    if (!currentItem) return <span>Client</span>;
    return (
        <span>{currentItem.first_name} {currentItem.last_name}</span>
    );
}

export default DynamicClientBreadCrumb;